module.exports = __webpack_public_path__ + "static/media/minus.3ff9cd4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/minus.svg
// module id = 1323
// module chunks = 0